import React, { ReactNode } from "react";
import Typography from "@mui/joy/Typography";

export const RightPaneTitle = (props: { children?: ReactNode; sx?: any }) => {
  return (
    <Typography
      fontWeight={200}
      sx={{
        fontSize: {
          xs: "20px",
          sm: "20px",
        },
        textTransform: "uppercase",
        letterSpacing: ".4rem",
      }}
      {...props}
    />
  );
};
